"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeUriComponentIfEncoded = exports.getRelativeUrl = exports.getRelativeUrlData = exports.getRelativeEncodedUrl = void 0;
const getRelativeEncodedUrl = (url, baseUrl) => (0, exports.getRelativeUrlData)(url, baseUrl).relativeEncodedUrl;
exports.getRelativeEncodedUrl = getRelativeEncodedUrl;
const getRelativeUrlData = (url, baseUrl) => {
    const relativePathname = getRelativePathname(url, baseUrl);
    const relativePathnameParts = getPathnameDecodedParts(relativePathname);
    const relativeUrl = pathnamePartsToRelativeUrl(relativePathnameParts);
    const relativeEncodedUrl = pathnamePartsToRelativeUrl(getPathnameParts(relativePathname));
    return {
        relativePathnameParts,
        relativeUrl,
        relativeEncodedUrl,
    };
};
exports.getRelativeUrlData = getRelativeUrlData;
const getRelativePathname = (url, baseUrl) => {
    const parsedUrl = new URL(url, `${baseUrl}/`);
    const parsedBaseUrl = new URL(baseUrl);
    return parsedUrl.pathname.replace(parsedBaseUrl.pathname, '');
};
const getPathnameDecodedParts = (relativePathname) => {
    const cleanPath = removeLeadingAndTrailingSlash(relativePathname);
    return (0, exports.decodeUriComponentIfEncoded)(cleanPath).split('/');
};
const pathnamePartsToRelativeUrl = (pathnameParts) => `./${pathnameParts.join('/')}`;
const getPathnameParts = (relativePathname) => removeLeadingAndTrailingSlash(relativePathname).split('/');
const removeLeadingAndTrailingSlash = (str) => /^\/?(.*?)\/?$/.exec(str)[1];
const getRelativeUrl = (url, baseUrl) => (0, exports.getRelativeUrlData)(url, baseUrl).relativeUrl;
exports.getRelativeUrl = getRelativeUrl;
const decodeUriComponentIfEncoded = (uriStr) => {
    try {
        return decodeURIComponent(uriStr);
    }
    catch (e) {
        return uriStr;
    }
};
exports.decodeUriComponentIfEncoded = decodeUriComponentIfEncoded;
//# sourceMappingURL=utils.js.map